import React from 'react';
import { ReactComponent as DoctorsIcon } from '../assets/icons/Doctor.svg';
import { ReactComponent as NutritionistIcon } from '../assets/icons/Nutritionist.svg';
import { ReactComponent as ClinicsIcon } from '../assets/icons/Buildings.svg';
import { ReactComponent as MembersIcon } from '../assets/icons/Users.svg';
import { ReactComponent as BellIcon } from '../assets/icons/Bell-grey.svg';
import { ReactComponent as DoctorsIconW } from '../assets/icons/Doctor-w.svg';
import { ReactComponent as NutritionistIconW } from '../assets/icons/Nutritionist-w.svg';
import { ReactComponent as ClinicsIconW } from '../assets/icons/Buildings-w.svg';
import { ReactComponent as MembersIconW } from '../assets/icons/Users-w.svg';
import { ReactComponent as BellIconW } from '../assets/icons/Bell.svg';
import { ReactComponent as BodySystems } from '../assets/icons/Refresh.svg';
import { ReactComponent as BodySystemsW } from '../assets/icons/Refresh-w.svg';
import { ReactComponent as FilesIcon } from '../assets/icons/File.svg';
import { ReactComponent as FilesIconW } from '../assets/icons/File2.svg';
import { ReactComponent as AppointmentsIcon } from '../assets/icons/Calendar2.svg';
import { ReactComponent as AppointmentsIconW } from '../assets/icons/Calendar2-w.svg';
import { ReactComponent as ChatIcon } from '../assets/icons/Chat.svg';
import { ReactComponent as ChatIconW } from '../assets/icons/Chat-w.svg';
import { ReactComponent as AdminsIcon } from '../assets/icons/admins.svg';
import { ReactComponent as AdminsIconW } from '../assets/icons/adminsW.svg';
import { ReactComponent as DisplayIcon } from '../assets/icons/Display.svg';
import { ReactComponent as DisplayIconW } from '../assets/icons/Display-w.svg';
import { ReactComponent as TrackerIcon } from '../assets/icons/tracker-icon.svg';
import { ReactComponent as TrackerIconW } from '../assets/icons/tracker-icon-w.svg';
import { DoctorSpecializationsList } from '../types/doctors';
import {
  MealType,
  MeasurementUnits,
  RaceEnum,
  UserGenderEnum
} from '../types/apiGeneratedTypes';

// API prefixes
export const API_V1_PREFIX = 'api/v1/';
export const AUTH_API_PREFIX = 'auth/';
export const PHARMA_API_PREFIX = 'pharmacy/';
export const DOCTORS_API_PREFIX = 'doctors/';
export const MEMBERS_API_PREFIX = 'members/';
export const TEST_RESULTS_API_PREFIX = 'test-results/';
export const CLIENTS_API_PREFIX = 'clients/';
export const COUNTERS_API_PREFIX = 'counter/';
export const TESTS_API_PREFIX = 'test/';
export const SYSTEMS_API_PREFIX = 'body-system/';
export const BIOMARKERS_API_PREFIX = 'biomarker/';
export const CLINICS_API_PREFIX = 'clinic/';
export const APPOINT_API_PREFIX = 'appointment/';
export const DIET_API_PREFIX = 'diet-diary/';
export const HEALTH_API_PREFIX = 'health-summary/';
export const QUESTIONS_API_PREFIX = 'questions/';
export const FILES_API_PREFIX = 'file-storage/';
export const ADVICE_API_PREFIX = 'advice/';
export const NOTES_API_PREFIX = 'notes/';
export const FAQ_API_PREFIX = 'faq/';
export const FOOD_API_PREFIX = 'food/';
export const SUPPLEMENTS_API_PREFIX = 'supplements/';
export const SUPPLEMENT_REGIMES_API_PREFIX = 'supplement-regimes/';
export const NUTRITIONIST_API_PREFIX = 'nutritionists/';
export const RECOMMENDATIONS_API_PREFIX = 'recommendations/';
export const NOTE_TEMPLATE_API_PREFIX = 'note-template/';
export const QUOTES_API_PREFIX = 'quotes/';
export const isProd = process.env.NODE_ENV === 'production';
export const TAGS_API_PREFIX = 'tags/';
export const PMP_MODALITIES_API_PREFIX = 'pmp-modalities/';
export const PMP_ALERTS_API_PREFIX = 'pmp-alerts/';
export const MRI_CONDITIONS_API_PREFIX = 'mri-conditions/';
export const RADIOLOGIST_BODY_SYSTEMS_API_PREFIX = 'mri-conditions/radiologist-body-systems/';
export const RADIOLOGY_ORGANS_API_PREFIX = 'mri-conditions/organs/';

export const FULL_BODY_SCAN_BASE_URL = isProd
  ? process.env.REACT_APP_FULL_BODY_SCAN_URL_PROD
  : process.env.REACT_APP_FULL_BODY_SCAN_URL_DEV;

export const getFullImageUrl = (imagePath: string | null | undefined): string => {
  if (!imagePath) return '';
  
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }
  
  if (imagePath.startsWith('static/')) {
    return `https://corevital-olearis.s3.eu-north-1.amazonaws.com/${imagePath}`;
  }
  
  const baseUrl = isProd 
    ? process.env.REACT_APP_API_BASE_URL_IMG 
    : process.env.REACT_APP_API_BASE_URL_IMG;
  
  if (!baseUrl) {
    console.warn('REACT_APP_API_BASE_URL_IMG not configured, using S3 fallback');
    return `https://corevital-olearis.s3.eu-north-1.amazonaws.com/${imagePath}`;
  }
  
  const cleanBaseUrl = baseUrl?.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
  const cleanImagePath = imagePath.startsWith('/') ? imagePath.slice(1) : imagePath;
  
  return `${cleanBaseUrl}/${cleanImagePath}`;
};

export const AUTH0_DOMAIN = isProd
  ? process.env.REACT_APP_AUTH0_APP_URL_PROD
  : process.env.REACT_APP_AUTH0_APP_URL_DEV;

export const AUTH0_CLIENT_ID = isProd
  ? process.env.REACT_APP_AUTH0_CLIENT_ID_PROD
  : process.env.REACT_APP_AUTH0_CLIENT_ID_DEV;

export const AUTH0_AUDIENCE = isProd
  ? process.env.REACT_APP_AUTH0_AUDIENCE_PROD
  : process.env.REACT_APP_AUTH0_AUDIENCE_DEV;

export const GTM_CONTAINER_ID = process.env.REACT_APP_GTM_CONTAINER_ID;

export const sidebarLinks: {
  title: string;
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  activeIcon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  link: string;
  showCount?: boolean;
}[] = [
    {
      title: 'CV Dashboard',
      icon: TrackerIcon,
      activeIcon: TrackerIconW,
      link: '/cv-dashboard'
    },
    {
      title: 'Admin',
      icon: AdminsIcon,
      activeIcon: AdminsIconW,
      link: '/'
    },
    {
      title: 'Doctors',
      icon: DoctorsIcon,
      activeIcon: DoctorsIconW,
      link: '/doctors'
    },
    {
      title: 'Nutritionists',
      icon: NutritionistIcon,
      activeIcon: NutritionistIconW,
      link: '/nutritionists'
    },
    {
      title: 'Teams',
      icon: DisplayIcon,
      activeIcon: DisplayIconW,
      link: '/teams'
    },
    {
      title: 'Clinics',
      icon: ClinicsIcon,
      activeIcon: ClinicsIconW,
      link: '/clinics'
    },
    {
      title: 'Members',
      icon: MembersIcon,
      activeIcon: MembersIconW,
      link: '/members'
    },
    {
      title: 'Medical Library',
      icon: BodySystems,
      activeIcon: BodySystemsW,
      link: '/body-systems'
    },
    {
      title: 'Website CMS',
      icon: FilesIcon,
      activeIcon: FilesIconW,
      link: '/marketing-cms'
    },
    {
      title: 'Alerts',
      icon: BellIcon,
      activeIcon: BellIconW,
      link: '/alerts',
      showCount: true
    },
    {
      title: 'Chat',
      icon: ChatIcon,
      activeIcon: ChatIconW,
      link: '/chat',
      showCount: true
    },
    {
      title: 'Inuvi Files',
      icon: FilesIcon,
      activeIcon: FilesIconW,
      link: '/inuvi-files'
    },
    {
      title: 'Global Appointment',
      icon: AppointmentsIcon,
      activeIcon: AppointmentsIconW,
      link: '/appointments'
    },
    {
      title: 'Blood Upload Tracker',
      icon: TrackerIcon,
      activeIcon: TrackerIconW,
      link: '/blood-upload-tracker'
    },
    {
      title: 'Failed Payments',
      icon: TrackerIcon,
      activeIcon: TrackerIconW,
      link: '/failed-payments'
    },
     {
      title: 'Scheduler',
      icon: AppointmentsIcon,
      activeIcon: AppointmentsIconW,
      link: '/scheduler'
    },
    {
      title: 'AI Logs',
      icon: FilesIcon,
      activeIcon: FilesIconW,
      link: '/audit-logs'
    }
  ];

export enum DoctorSpecializationEnum {
  GENERAL_PRACTICE = 1,
  INTERNAL_MEDICINE = 2,
  PEDIATRICS = 3,
  GERIATRICS = 4,
  GENERAL_SURGERY = 5,
  CARDIOTHORACIC_SURGERY = 6,
  NEUROSURGERY = 7,
  ORTHOPEDIC_SURGERY = 8,
  PLASTIC_AND_RECONSTRUCTIVE_SURGERY = 9,
  PEDIATRIC_SURGERY = 10,
  VASCULAR_SURGERY = 11,
  TRAUMA_SURGERY = 12,
  TRANSPLANT_SURGERY = 13,
  OTOLARYNGOLOGY_ENT_SURGERY = 14,
  ORAL_AND_MAXILLOFACIAL_SURGERY = 15,
  UROLOGY = 16,
  CARDIOLOGY = 17,
  ENDOCRINOLOGY = 18,
  GASTROENTEROLOGY = 19,
  HEMATOLOGY = 20,
  INFECTIOUS_DISEASE = 21,
  NEPHROLOGY = 22,
  PULMONOLOGY = 23,
  RHEUMATOLOGY = 24,
  ALLERGY_AND_IMMUNOLOGY = 25,
  DERMATOLOGY = 26,
  NEUROLOGY = 27,
  ONCOLOGY = 28,
  PSYCHIATRY = 29,
  SLEEP_MEDICINE = 30,
  ANESTHESIOLOGY = 31,
  PATHOLOGY = 32,
  RADIOLOGY_DIAGNOSTIC_AND_INTERVENTIONAL = 33,
  NUCLEAR_MEDICINE = 34,
  OBSTETRICS_AND_GYNECOLOGY_OB_GYN = 35,
  MATERNAL_FETAL_MEDICINE_HIGH_RISK_PREGNANCY = 36,
  GYNECOLOGIC_ONCOLOGY = 37,
  REPRODUCTIVE_ENDOCRINOLOGY_AND_INFERTILITY = 38,
  UROGYNECOLOGY = 39,
  EMERGENCY_MEDICINE = 40,
  CRITICAL_CARE_MEDICINE = 41,
  ACUTE_MEDICINE = 42,
  PEDIATRIC_CARDIOLOGY = 43,
  PEDIATRIC_ENDOCRINOLOGY = 44,
  PEDIATRIC_GASTROENTEROLOGY = 45,
  PEDIATRIC_HEMATOLOGY_ONCOLOGY = 46,
  PEDIATRIC_NEPHROLOGY = 47,
  PEDIATRIC_NEUROLOGY = 48,
  PEDIATRIC_PULMONOLOGY = 49,
  PEDIATRIC_RHEUMATOLOGY = 50,
  OCCUPATIONAL_MEDICINE = 51,
  AEROSPACE_MEDICINE = 52,
  PUBLIC_HEALTH_MEDICINE = 53,
  ADDICTION_MEDICINE = 54,
  SPORTS_MEDICINE = 55,
  PALLIATIVE_CARE_MEDICINE = 56,
  PAIN_MANAGEMENT = 57,
  HYPERBARIC_MEDICINE = 58,
  CLINICAL_GENETICS = 59
}

export const DoctorSpecializations: DoctorSpecializationsList = [
  { key: DoctorSpecializationEnum.GENERAL_PRACTICE, value: 'General Practice' },
  {
    key: DoctorSpecializationEnum.INTERNAL_MEDICINE,
    value: 'Internal Medicine'
  },
  { key: DoctorSpecializationEnum.PEDIATRICS, value: 'Pediatrics' },
  { key: DoctorSpecializationEnum.GERIATRICS, value: 'Geriatrics' },
  { key: DoctorSpecializationEnum.GENERAL_SURGERY, value: 'General Surgery' },
  {
    key: DoctorSpecializationEnum.CARDIOTHORACIC_SURGERY,
    value: 'Cardiothoracic Surgery'
  },
  { key: DoctorSpecializationEnum.NEUROSURGERY, value: 'Neurosurgery' },
  {
    key: DoctorSpecializationEnum.ORTHOPEDIC_SURGERY,
    value: 'Orthopedic Surgery'
  },
  {
    key: DoctorSpecializationEnum.PLASTIC_AND_RECONSTRUCTIVE_SURGERY,
    value: 'Plastic and Reconstructive Surgery'
  },
  {
    key: DoctorSpecializationEnum.PEDIATRIC_SURGERY,
    value: 'Pediatric Surgery'
  },
  { key: DoctorSpecializationEnum.VASCULAR_SURGERY, value: 'Vascular Surgery' },
  { key: DoctorSpecializationEnum.TRAUMA_SURGERY, value: 'Trauma Surgery' },
  {
    key: DoctorSpecializationEnum.TRANSPLANT_SURGERY,
    value: 'Transplant Surgery'
  },
  {
    key: DoctorSpecializationEnum.OTOLARYNGOLOGY_ENT_SURGERY,
    value: 'Otolaryngology ENT Surgery'
  },
  {
    key: DoctorSpecializationEnum.ORAL_AND_MAXILLOFACIAL_SURGERY,
    value: 'Oral and Maxillofacial Surgery'
  },
  { key: DoctorSpecializationEnum.UROLOGY, value: 'Urology' },
  { key: DoctorSpecializationEnum.CARDIOLOGY, value: 'Cardiology' },
  { key: DoctorSpecializationEnum.ENDOCRINOLOGY, value: 'Endocrinology' },
  { key: DoctorSpecializationEnum.GASTROENTEROLOGY, value: 'Gastroenterology' },
  { key: DoctorSpecializationEnum.HEMATOLOGY, value: 'Hematology' },
  {
    key: DoctorSpecializationEnum.INFECTIOUS_DISEASE,
    value: 'Infectious Disease'
  },
  { key: DoctorSpecializationEnum.NEPHROLOGY, value: 'Nephrology' },
  { key: DoctorSpecializationEnum.PULMONOLOGY, value: 'Pulmonology' },
  { key: DoctorSpecializationEnum.RHEUMATOLOGY, value: 'Rheumatology' },
  {
    key: DoctorSpecializationEnum.ALLERGY_AND_IMMUNOLOGY,
    value: 'Allergy and Immunology'
  },
  { key: DoctorSpecializationEnum.DERMATOLOGY, value: 'Dermatology' },
  { key: DoctorSpecializationEnum.NEUROLOGY, value: 'Neurology' },
  { key: DoctorSpecializationEnum.ONCOLOGY, value: 'Oncology' },
  { key: DoctorSpecializationEnum.PSYCHIATRY, value: 'Psychiatry' },
  { key: DoctorSpecializationEnum.SLEEP_MEDICINE, value: 'Sleep Medicine' },
  { key: DoctorSpecializationEnum.ANESTHESIOLOGY, value: 'Anesthesiology' },
  { key: DoctorSpecializationEnum.PATHOLOGY, value: 'Pathology' },
  {
    key: DoctorSpecializationEnum.RADIOLOGY_DIAGNOSTIC_AND_INTERVENTIONAL,
    value: 'Radiology Diagnostic and Interventional'
  },
  { key: DoctorSpecializationEnum.NUCLEAR_MEDICINE, value: 'Nuclear Medicine' },
  {
    key: DoctorSpecializationEnum.OBSTETRICS_AND_GYNECOLOGY_OB_GYN,
    value: 'Obstetrics and Gynecology OB GYN'
  },
  {
    key: DoctorSpecializationEnum.MATERNAL_FETAL_MEDICINE_HIGH_RISK_PREGNANCY,
    value: 'Maternal Fetal Medicine High Risk Pregnancy'
  },
  {
    key: DoctorSpecializationEnum.GYNECOLOGIC_ONCOLOGY,
    value: 'Gynecologic Oncology'
  },
  {
    key: DoctorSpecializationEnum.REPRODUCTIVE_ENDOCRINOLOGY_AND_INFERTILITY,
    value: 'Reproductive Endocrinology and Infertility'
  },
  { key: DoctorSpecializationEnum.UROGYNECOLOGY, value: 'Urogynecology' },
  {
    key: DoctorSpecializationEnum.EMERGENCY_MEDICINE,
    value: 'Emergency Medicine'
  },
  {
    key: DoctorSpecializationEnum.CRITICAL_CARE_MEDICINE,
    value: 'Critical Care Medicine'
  },
  { key: DoctorSpecializationEnum.ACUTE_MEDICINE, value: 'Acute Medicine' },
  {
    key: DoctorSpecializationEnum.PEDIATRIC_CARDIOLOGY,
    value: 'Pediatric Cardiology'
  },
  {
    key: DoctorSpecializationEnum.PEDIATRIC_ENDOCRINOLOGY,
    value: 'Pediatric Endocrinology'
  },
  {
    key: DoctorSpecializationEnum.PEDIATRIC_GASTROENTEROLOGY,
    value: 'Pediatric Gastroenterology'
  },
  {
    key: DoctorSpecializationEnum.PEDIATRIC_HEMATOLOGY_ONCOLOGY,
    value: 'Pediatric Hematology Oncology'
  },
  {
    key: DoctorSpecializationEnum.PEDIATRIC_NEPHROLOGY,
    value: 'Pediatric Nephrology'
  },
  {
    key: DoctorSpecializationEnum.PEDIATRIC_NEUROLOGY,
    value: 'Pediatric Neurology'
  },
  {
    key: DoctorSpecializationEnum.PEDIATRIC_PULMONOLOGY,
    value: 'Pediatric Pulmonology'
  },
  {
    key: DoctorSpecializationEnum.PEDIATRIC_RHEUMATOLOGY,
    value: 'Pediatric Rheumatology'
  },
  {
    key: DoctorSpecializationEnum.OCCUPATIONAL_MEDICINE,
    value: 'Occupational Medicine'
  },
  {
    key: DoctorSpecializationEnum.AEROSPACE_MEDICINE,
    value: 'Aerospace Medicine'
  },
  {
    key: DoctorSpecializationEnum.PUBLIC_HEALTH_MEDICINE,
    value: 'Public Health Medicine'
  },
  {
    key: DoctorSpecializationEnum.ADDICTION_MEDICINE,
    value: 'Addiction Medicine'
  },
  { key: DoctorSpecializationEnum.SPORTS_MEDICINE, value: 'Sports Medicine' },
  {
    key: DoctorSpecializationEnum.PALLIATIVE_CARE_MEDICINE,
    value: 'Palliative Care Medicine'
  },
  { key: DoctorSpecializationEnum.PAIN_MANAGEMENT, value: 'Pain Management' },
  {
    key: DoctorSpecializationEnum.HYPERBARIC_MEDICINE,
    value: 'Hyperbaric Medicine'
  },
  {
    key: DoctorSpecializationEnum.CLINICAL_GENETICS,
    value: 'Clinical Genetics'
  }
];

export const specNames = DoctorSpecializations.reduce(
  (result, { key, value }) => {
    result[key] = value;
    return result;
  },
  {} as Record<DoctorSpecializationEnum, string>
);
export const doctorFilters = DoctorSpecializations.reduce(
  (result, { key, value }) => {
    result.push({ key: `${key}`, title: value });
    return result;
  },
  [] as { title: string; key: string }[]
);

export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

export const biomarkerMeasurementUnits = [
  { key: MeasurementUnits.MgL, value: 'mg/L' },
  { key: MeasurementUnits.MmolL, value: 'mmol/L' },
  { key: MeasurementUnits.NgML, value: 'ng/mL' },
  { key: MeasurementUnits.PgML, value: 'pg/mL' },
  { key: MeasurementUnits.MgDL, value: 'mg/dL' },
  { key: MeasurementUnits.GDL, value: 'g/dL' },
  { key: MeasurementUnits.CellsΜL, value: 'cells/μL' },
  { key: MeasurementUnits.Value, value: '%' },
  { key: MeasurementUnits.Ratio, value: 'Ratio' },
  { key: MeasurementUnits.GL, value: 'g/L' },
  { key: MeasurementUnits.Pg, value: 'pg' },
  { key: MeasurementUnits.Femtoliters, value: 'femtoliters' },
  { key: MeasurementUnits.X109L, value: 'x 10^9/L' },
  { key: MeasurementUnits.Value10L, value: '× 10¹²/L' },
  { key: MeasurementUnits.IUML, value: 'IU/mL' },
  { key: MeasurementUnits.UML, value: 'U/mL' },
  { key: MeasurementUnits.MIUL, value: 'mIU/L' },
  { key: MeasurementUnits.PmolL, value: 'pmol/L' },
  { key: MeasurementUnits.NmolL, value: 'nmol/L' },
  { key: MeasurementUnits.NA, value: 'N/A' },
  { key: MeasurementUnits.MIUmL, value: 'mIUmL' },
  { key: MeasurementUnits.IUL, value: 'IU/L' },
  { key: MeasurementUnits.KUL, value: 'kU/L' },
  { key: MeasurementUnits.UL, value: 'U/L' },
  { key: MeasurementUnits.UmolL, value: 'umol/L' },
  { key: MeasurementUnits.MmolMol, value: 'mmol/mol' },
  { key: MeasurementUnits.MicromolL, value: 'micromol/L' },
  { key: MeasurementUnits.ValueGL, value: 'µg/L' },
  { key: MeasurementUnits.ValueMolL, value: 'µmol/L' },
  { key: MeasurementUnits.NgL, value: 'ng/L' },
  { key: MeasurementUnits.MmLitre, value: 'mm/litre' },
  { key: MeasurementUnits.MmHour, value: 'mm/hour' },
  { key: MeasurementUnits.MLMin173M2, value: 'mL/min/1.73m^2' },
  { key: MeasurementUnits.KIU_L, value: 'kIU/L' }
];

/** Selectable options in  UI (Male / Female only). */
export const genders = [
  { key: UserGenderEnum.Male, value: 'Male' },
  { key: UserGenderEnum.Female, value: 'Female' }
];

/**gender values for read-only display. */
export const genderDisplayOptions = [
  { key: UserGenderEnum.Male, value: 'Male' },
  { key: UserGenderEnum.Female, value: 'Female' },
  { key: UserGenderEnum.Other, value: 'Other' },
  { key: UserGenderEnum.PreferNotToSay, value: 'I prefer not to say' }
];

export const getGenderDisplayLabel = (gender?: string | null): string => {
  if (!gender) return '-';
  const match = genderDisplayOptions.find((option) => option.key === gender);
  return match?.value ?? gender;
};
export const races = [
  { key: RaceEnum.Asian, value: 'Asian (including Asian British)' },
  { key: RaceEnum.Black, value: 'Black (including Black British)' },
  { key: RaceEnum.Latino, value: 'Latino Hispanic' },
  { key: RaceEnum.Mixed, value: 'Mixed or Multiple ethnic groups' },
  { key: RaceEnum.White, value: 'White' },
  { key: RaceEnum.NotSay, value: 'I prefer not to say' }
];

export const getRaceDisplayLabel = (race?: string | null): string => {
  if (!race) return '-';
  const match = races.find((option) => option.key === race);
  return match?.value ?? race;
};
export const smokingTypes = [
  { key: 'cigarettes', value: 'Cigarettes' },
  { key: 'cigars', value: 'Cigars' },
  { key: 'dip', value: 'Dip' },
  { key: 'dissolvable', value: 'Dissolvable' },
  { key: 'tobacco', value: 'Tobacco' },
  { key: 'vape', value: 'Vape' },
  { key: 'shisha', value: 'Shisha' },
  { key: 'kreteks', value: 'Kreteks' },
  { key: 'pipe', value: 'Pipe' }
];
export const exercisesTypes = [
  { key: 'cardiovascular', value: 'Cardiovascular' },
  {
    key: 'strength_and_resistance',
    value: 'Strength and resistance training'
  }
];
export const lengthMeasurementTypes = [
  { key: 'cm', value: 'cm' },
  {
    key: 'feet',
    value: 'feet'
  }
];
export const weightMeasurementTypes = [
  { key: 'kg', value: 'kg' },
  {
    key: 'stones',
    value: 'stones'
  }
];

export const mobilityTypes = [
  {
    key: '0',
    value:
      'Fully active, no restrictions on activities. A performance status of 0 means no restrictions in the sense that someone is able to do everything they were able to do prior to their diagnosis.'
  },
  {
    key: '1',
    value:
      "Unable to do strenuous activities, but able to carry out light housework and sedentary activities. This status basically means you can't do heavy work but can do anything else."
  },
  {
    key: '2',
    value:
      'Able to walk and manage self-care, but unable to work. Out of bed more than 50% of waking hours. In this category, people are usually unable to carry on any work activities, including light office work.'
  },
  {
    key: '3',
    value:
      'Confined to bed or a chair more than 50% of waking hours. Capable of limited self-care.'
  },
  {
    key: '4',
    value:
      'Completely disabled. Totally confined to a bed or chair. Unable to do any self-care.'
  }
];

export const mealTypesNames = {
  [MealType.Breakfast]: 'Breakfast',
  [MealType.Lunch]: 'Lunch',
  [MealType.Dinner]: 'Dinner',
  [MealType.Snack]: 'Snack',
  [MealType.Supper]: 'Supper'
};

export const emailRegexp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export const statusTranslations = {
  DATE_SCHEDULED: 'Date Scheduled',
  COMPLETED: 'Completed',
  RUNNING_LATE: 'Running late',
  TO_BE_RESCHEDULED: 'To be rescheduled',
  CUSTOMER_QUERY: 'Customer query',
  DNA: 'DNA'
} as const;

export const statusOptions = Object.entries(statusTranslations).map(
  ([value, label]) => ({ value, label })
);

export const NOTE_TEMPLATE_CATEGORIES = [
  { key: 'gp_note', value: 'GP Note' },
  { key: 'nutritionist_note', value: 'Nutritionist Note' },
  { key: 'fbs_note', value: 'FBS Note' },
  { key: 'admin_note', value: 'Admin Note' },
  { key: 'instructions_note', value: 'Instructions Note' },
  { key: 'misc_note', value: 'Misc Note' },
];

export const notesCategory = [
  { key: 'regular', value: 'Regular Notes' },
  { key: 'fbs_note', value: 'FBS Notes' },
  { key: 'follow_on_plans', value: 'Follow on plans' }
];

export const applicableModalities = [
  { key: 'FBS', value: 'FBS' },
  { key: 'BLOODS', value: 'Bloods' },
  { key: 'DEXA', value: 'DEXA' },
  { key: 'PRS', value: 'PRS' },
  { key: 'CT_ANGIOGRAM', value: 'CT Angiogram' },
  { key: 'MRI', value: 'MRI' }
];

export const FUTURE_TEST_MODALITY_OPTIONS = [
  { key: 'FBS', value: 'FBS' },
  { key: 'BLOODS', value: 'Bloods' },
  { key: 'DEXA', value: 'DEXA' },
  { key: 'PRS', value: 'PRS' },
  { key: 'CT_ANGIOGRAM', value: 'CT Angiogram' },
  { key: 'MRI', value: 'MRI' },
  { key: 'ULTRASOUND', value: 'Ultrasound' },
  { key: 'X_RAY', value: 'X-Ray' },
];

export const PMP_MODALITY_NAME_OPTIONS = [
  { key: 'Full Body Scan', value: 'Full Body Scan' },
  { key: 'MRI', value: 'MRI' },
  { key: 'MRI with Contrast', value: 'MRI with Contrast' },
  { key: 'Ultrasound', value: 'Ultrasound' },
  { key: 'Blood Tests', value: 'Blood Tests' },
  { key: 'DEXA', value: 'DEXA' },
  { key: 'CT Angio', value: 'CT Angio' },
  { key: 'CT Calcium Score', value: 'CT Calcium Score' },
  { key: 'Polygenic Risk Scoring', value: 'Polygenic Risk Scoring' },
  { key: 'X-Ray', value: 'X-Ray' },
  { key: 'CT', value: 'CT' },
];

export const normalizeFutureTestModalityKey = (
  modality?: string | null
): string | null => {
  if (!modality) return null;
  const normalized = modality.trim().toUpperCase().replace(/[\s-]+/g, '_');
  const match = FUTURE_TEST_MODALITY_OPTIONS.find(
    (option) =>
      option.key === normalized ||
      option.key.toLowerCase() === modality.toLowerCase() ||
      option.value.toLowerCase() === modality.toLowerCase()
  );
  return match?.key ?? null;
};

export const getFutureTestModalityLabel = (modality?: string | null): string => {
  if (!modality) return '-';
  const key = normalizeFutureTestModalityKey(modality);
  const match = FUTURE_TEST_MODALITY_OPTIONS.find((option) => option.key === key);
  return match?.value ?? modality;
};

export const MRI_BODY_PART_OPTIONS = [
  { key: 'abdomen', value: 'Abdomen' },
  { key: 'ankle_right', value: 'Ankle - right' },
  { key: 'ankle_left', value: 'Ankle - left' },
  { key: 'bladder', value: 'Bladder' },
  { key: 'bowel', value: 'Bowel' },
  { key: 'brain', value: 'Brain' },
  { key: 'breast', value: 'Breast' },
  { key: 'carpal_tunnel', value: 'Carpal Tunnel' },
  { key: 'chest', value: 'Chest' },
  { key: 'colon', value: 'Colon' },
  { key: 'foot_right', value: 'Foot - right' },
  { key: 'foot_left', value: 'Foot - left' },
  {
    key: 'gallbladder_bile_ducts_pancreas_mrcp',
    value: 'Gallbladder and bile ducts and pancreas (MRCP)',
  },
  { key: 'hand_right', value: 'Hand - right' },
  { key: 'hand_left', value: 'Hand - left' },
  { key: 'head', value: 'Head' },
  { key: 'hip', value: 'Hip' },
  { key: 'ilium', value: 'Ilium' },
  { key: 'kidneys', value: 'Kidneys' },
  { key: 'knee_right', value: 'Knee - right' },
  { key: 'knee_left', value: 'Knee - left' },
  { key: 'lower_back_lumbar_spine', value: 'Lower Back (Lumbar Spine)' },
  { key: 'lower_leg_right', value: 'Lower Leg - right' },
  { key: 'lower_leg_left', value: 'Lower Leg - left' },
  { key: 'mastoid', value: 'Mastoid' },
  { key: 'neck_cervical_spine', value: 'Neck (Cervical Spine)' },
  { key: 'oral_cavity', value: 'Oral cavity' },
  { key: 'pancreas', value: 'Pancreas' },
  { key: 'patella_knee_right', value: 'Patella (knee) - right' },
  { key: 'patella_knee_left', value: 'Patella (knee) - left' },
  { key: 'pelvis', value: 'Pelvis' },
  { key: 'pituitary', value: 'Pituitary' },
  { key: 'prostate', value: 'Prostate' },
  { key: 'radius_ulna_arm_right', value: 'Radius-ulna (arm) - right' },
  { key: 'radius_ulna_arm_left', value: 'Radius-ulna (arm) - left' },
  { key: 'renal', value: 'Renal' },
  { key: 'sacroiliac_joint_right', value: 'Sacroiliac joint - right' },
  { key: 'sacroiliac_joint_left', value: 'Sacroiliac joint - left' },
  { key: 'scaphoid', value: 'Scaphoid' },
  { key: 'scrotum', value: 'Scrotum' },
  { key: 'shoulder_right', value: 'Shoulder - right' },
  { key: 'shoulder_left', value: 'Shoulder - left' },
  { key: 'sinuses', value: 'Sinuses' },
  { key: 'small_bowel', value: 'Small Bowel' },
  { key: 'small_intestine_enterography', value: 'Small Intestine (Enterography)' },
  { key: 'spinal_cord', value: 'Spinal cord' },
  { key: 'spine_lumbar_pelvis', value: 'Spine lumbar pelvis' },
  { key: 'spine_thoracic_spine_lumbar', value: 'Spine thoracic spine lumbar' },
  { key: 'spine_whole', value: 'Spine whole' },
  { key: 'sternum', value: 'Sternum' },
  { key: 'stomach', value: 'Stomach' },
  { key: 'upper_leg_right', value: 'Upper leg - right' },
  { key: 'upper_leg_left', value: 'Upper leg - left' },
  { key: 'thoracic_spine', value: 'Thoracic Spine' },
  { key: 'thorax', value: 'Thorax' },
  { key: 'toes_right', value: 'Toes - right' },
  { key: 'toes_left', value: 'Toes - left' },
  { key: 'urinary_bladder', value: 'Urinary bladder' },
  { key: 'urinary_tract', value: 'Urinary tract' },
];
